<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div class="content-section">
      <h1 class="header-style">
        Work Instance
      </h1>
      <br>
      <p class="subheader-style">
        Choose the work location for progress tracking.
      </p>
      <div
        class="info-message-style mb-4"
      >
        <p class="info-style">
          <v-icon
            color="#0277BD"
            size="30"
          >
            mdi-information-outline
          </v-icon> <br>
          Please check with your site manager for more details
        </p>
      </div>
      <v-card
        elevation="1"
        color="#FFF"
      >
        <v-form
          ref="form"
          v-model="isFormValid"
        >
          <v-card-title>
            <p class="process-header">
              Select Instance
            </p>
          </v-card-title>
          <v-card-text>
            <v-autocomplete
              v-model="selectedBudgetInstance"
              class="field-text-style"
              :items="budgetInstances"
              :rules="[(v) => !!v || 'This field is required']"
              label="Select Instance*"
              dense
              hint="Project admin has set the selected work item under instances list for tracking the progress."
              persistent-hint
              light
              outlined
              single-line
              prepend-inner-icon="mdi-file-document-multiple"
              item-value="id"
              item-text="name"
            />
            <br>
          </v-card-text>
        </v-form>
      </v-card>
      <v-btn
        color="#000"
        class="mt-5 btn-style"
        elevation="0"
        @click="storeInstanceDetails()"
      >
        Submit
      </v-btn>
      <v-btn
        light
        color="#E6E6E6"
        class="mt-3 btn-style"
        elevation="0"
        @click="showModal = false"
      >
        Cancel
      </v-btn>
    </div>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>

<script>
  import spinner from 'src/views/components/SpinnerCentre';
  import Constants from 'src/constants';

  export default {
    name: 'BudgetInstances',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        showModal: true,
        isFormValid: false,
        loading: false,
        selectedBudgetInstance: '',
      };
    },
    computed: {
      budgetInstances () {
        return this.$store.getters['projects/getBudgetInstances'];
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      async storeInstanceDetails () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
            return;
        }
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.showModal = false;
          this.$emit('store-instance', this.selectedBudgetInstance);
        }, 1000);
      },
    },
  };
</script>

<style scoped>
.title-style {
  color: #37474F;
  margin-left: 21px;
  margin-bottom: 10px;
}
.icon-style {
  color: #37474F;
  font-size: 55px;
  margin-right: 5px;
}
.field-style {
  margin-top: -10px;
  margin-bottom: 10px;
}
.my-p-style {
  margin-top: -10px;
  margin-bottom: -5px;
  font-size: 18px;
  font-weight: bold;
  color: #FF3700;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: center;
}
.my-p-style-sub {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}
.theme--dark.v-list{
  background-color: white!important;
}
.theme--dark >>> .v-list-item{
  color:#37474F!important;
}
</style>
